export default __webpack_public_path__ + "224382b.png";